import type { TGridProps } from "@/ui/components/layout/Grid";
import type { DefinedDefaults } from "@/ui/lib";

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TStackProps = TGridProps;

type TStackDefaultProps = DefinedDefaults<
  TStackProps,
  "data-component"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const STACK_DEFAULTS = {
  "data-component": "Stack",
} satisfies TStackDefaultProps;
